<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M2.667 9c0-.92.746-1.666 1.667-1.666h15.333c.92 0 1.667.746 1.667 1.667v14c0 .92-.747 1.666-1.667 1.666H4.334c-.92 0-1.667-.746-1.667-1.666V9zm23.858 13.19l-.871-.82a7.374 7.374 0 010-10.74l.87-.819c1.064-1.001 2.81-.247 2.81 1.214v9.952c0 1.46-1.746 2.214-2.81 1.213z"/></svg>
</template>

<script>
export default {
  name: 'objectsVideocameraFilled'
}
</script>
